import { Pipe, PipeTransform } from '@angular/core';
const manufacturers = [
	'acura',
	'amg',
	'aston martin',
	'audi',
	'bmw',
	'cadillac',
	'chevrolet',
	'cupra',
	'ferrari',
	'ford',
	'gibson',
	'honda',
	'hyundai',
	'lamborghini',
	'lexus',
	'mclaren',
	'mercedes-amg',
	'porsche',
	'praga',
	'toyota',
	'world',
];

const teamClasses = ['zp2', 'zr2', 'zr3'];

@Pipe({
	name: 'teamLogoLookup',
	standalone: true,
})
export class TeamLogoLookupPipe implements PipeTransform {
	transform(manufacturer: string, teamClass?: string): string {
		const lowerCaseManufacturer = manufacturer?.toLowerCase();
		const matchedManufacturer = manufacturers.find((m) => lowerCaseManufacturer?.includes(m));
		if (matchedManufacturer) {
			return `/assets/manufacturers/${matchedManufacturer}.png`;
		}

		const lowerCaseTeamClass = teamClass?.toLowerCase();
		const matchedClass = teamClasses.find((tc) => lowerCaseTeamClass?.includes(tc));
		if (matchedClass) {
			return `/assets/manufacturers/${matchedClass}.svg`;
		}

		return '/assets/manufacturers/default-logo.png';
	}
}
